import React from 'react';

const PostContext = React.createContext();

export { PostContext as default };